module.exports = __webpack_public_path__ + "img/AustinDeveloper.860191f7.png";